import { Divider } from 'antd';

import * as Styles from './MDivider.styles';

export const MDivider = () => <Divider className={Styles.divider} />;
